import { useNavigate, useSearchParams } from 'react-router-dom';
import { Nav } from '@/components/Nav';
import { Footer } from '@/components/Footer';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const bookingId = params.get('booking_id');

    return (
        <div className="bg-[#050505] min-h-screen text-[#F8F8F5]">
            <Nav />
            <div className="max-w-3xl mx-auto px-6 md:px-12 py-32 text-center">
                <XCircle size={64} className="text-[#A3A39D] mx-auto mb-8" />
                <div className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-4">Paiement annulé</div>
                <h1 className="font-display text-4xl md:text-5xl font-light mb-6">Aucun montant n'a été <em className="text-[#C5A059] not-italic">débité</em></h1>
                <p className="text-[#A3A39D]">Votre réservation est enregistrée{bookingId ? ` (ref ${bookingId.slice(0, 10).toUpperCase()})` : ''} mais non payée. Vous pouvez régler plus tard ou contacter notre équipe.</p>
                <div className="mt-12 flex gap-4 justify-center flex-wrap">
                    <button data-testid="cancel-home-btn" onClick={() => navigate('/')} className="border border-[#222] hover:border-[#C5A059] text-[#F8F8F5] px-8 py-3 text-xs uppercase tracking-[0.25em]">Accueil</button>
                    <button data-testid="cancel-new-btn" onClick={() => navigate('/reservation')} className="bg-[#C5A059] text-black px-8 py-3 text-xs uppercase tracking-[0.25em]">Nouvelle réservation</button>
                </div>
            </div>
            <Footer />
        </div>
    );
}
